export const adminCards = {
    adminSettingsCard: {
        entity: 'adminSettings',
        path: 'adminSettings',
        titleBar: { label: 'admin.settings.heading', mergeParams: ['settingsType'], new: 'admin.settings.title' },
        cardTitle: {
            title: 'all.form.button.more',
            buttons: [
                {
                    type: 'submit',
                    id: 'adminSettingsCard.save',
                    action: 'save',
                    label: 'all.form.button.save',
                    icon: 'save',
                    variant: 'primary',
                    confirm: false
                }
            ]
        },
        width: '756px',
        afterSubmit: { stay: true },
        sections: [
            {
                id: 'adminSettings.logo',
                meta: {
                    type: 'form',
                    width: '756px'
                },
                groups: [
                    {
                        type: 'upload',
                        id: 'logo',
                        field: 'logo',
                        fieldId: 'admin',
                        endpoint: 'adminSettings',
                        table: 'settings',
                        folder: 'logo'
                    }
                ],
                buttons: [
                    {
                        type: 'submit',
                        id: 'adminSettingsCard.logo.save',
                        action: 'save',
                        label: 'all.form.button.update',
                        icon: 'save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'companyName',
                    emptyMessage: 'admin.settings.form.empty.message',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'text',
                                    value: 'Company Logo',
                                    scale: 'title'
                                }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'adminSettings.companyData',
                meta: {
                    type: 'form',
                    width: '756px'
                },
                groups: [
                    {
                        type: 'description',
                        id: 'companyInformation',
                        label: 'admin.settings.companyData.title',
                        text: 'admin.settings.companyData.description'
                    },
                    {
                        type: 'separator',
                        id: 'separator'
                    },
                    {
                        type: 'text',
                        id: 'companyName',
                        label: 'admin.settings.companyName',
                        placeholder: 'admin.settings.companyName.placeholder',
                        required: true
                    },
                    {
                        type: 'text',
                        id: 'companyEmail',
                        label: 'admin.settings.companyEmail',
                        placeholder: 'admin.settings.companyEmail.placeholder',
                        required: true
                    },
                    {
                        type: 'text',
                        id: 'companyAddress_street',
                        label: 'admin.settings.companyAddress',
                        placeholder: 'admin.settings.companyAddress_street.placeholder',
                        required: true
                    },
                    {
                        type: 'group',
                        id: 'companyAddressPostCodeCity',
                        focus: false,
                        fields: [
                            {
                                type: 'text',
                                id: 'companyAddress_postCode',
                                placeholder: 'admin.settings.companyAddress.postcode',
                                autoComplete: 'postal-code'
                            },
                            {
                                type: 'text',
                                id: 'companyAddress_city',
                                placeholder: 'admin.settings.companyAddress.city',
                                focus: false,
                                autoComplete: 'address-level2'
                            },
                        ]
                    },
                    {
                        type: 'country',
                        id: 'companyCountry',
                        displayField: 'companyCountryName',
                        label: 'admin.settings.companyCountry',
                        placeholder: 'admin.settings.companyCountry.placeholder',
                        valueMap: { 'companyCountry': 'id', 'companyCountryName': 'name' },
                        defaultType: 'country'
                    },
                ],
                buttons: [
                    {
                        type: 'submit',
                        id: 'adminSettingsCard.companyData.save',
                        action: 'save',
                        label: 'all.form.button.update',
                        icon: 'save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'companyName',
                    emptyMessage: 'admin.settings.form.empty.message',
                    columns: [
                        {
                            weight: 7,
                            basis: '70%',
                            elements: [
                                {
                                    type: 'text',
                                    value: 'Company Information',
                                    scale: 'title'
                                },
                                {
                                    type: 'field',
                                    value: 'companyName',
                                    scale: 'normal'
                                },
                                {
                                    type: 'field',
                                    value: 'companyAddress_street',
                                    scale: 'normal'
                                },
                                {
                                    type: 'merge',
                                    value: '${1} - ${2}',
                                    mergeParams: ['companyAddress_postCode', 'companyAddress_city'],
                                    scale: 'normal'
                                },
                            ],
                        },
                        {
                            weight: 3,
                            basis: '30%',
                            align: 'end',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'companyEmail',
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            },
        ]
    },

    createOrgCardOrganization: {
        entity: 'organization',
        path: 'organization',
        titleBar: { mergeParams: ['name'], new: 'organization.form.new.title' },
        cardTitle: {
            title: 'organization.form.new.title',
            menuItems: [
            ]
        },
        showCardTitle: false,
        afterSubmit: { stay: true },
        sections: [{
            id: 'createOrgOrg',
            meta: {
                type: 'form',
                collapsible: false,
                width: '480px'
            },
            groups: [
                /*
                 * The organisation's name doubles as a company register lookup,
                 * as on the contact card: picking a company fills the name and
                 * address, and sets the country to the company's. The form has
                 * no tax field, so the registration number is not kept here.
                 */
                {
                    type: 'companyLookup',
                    id: 'name',
                    parameter: 'country',
                    label: 'createOrg.form.org.name',
                    placeholder: 'createOrg.form.org.name.placeholder',
                    valueMap: {
                        'name': 'name',
                        'address_street': 'address.street',
                        'address_postCode': 'address.postalCode',
                        'address_city': 'address.city'
                    }
                },
                {
                    type: 'email',
                    id: 'email',
                    label: 'createOrg.form.org.email',
                    placeholder: 'createOrg.form.org.email.placeholder',
                },
                {
                    type: 'text',
                    id: 'address_street',
                    label: 'createOrg.form.org.address',
                    placeholder: 'createOrg.form.org.address.street',
                    fgMargin: '1.5rem',
                    autoComplete: 'address-line1'
                },
                {
                    type: 'group',
                    id: 'addressPostCodeCity',
                    fields: [
                        {
                            type: 'text',
                            id: 'address_postCode',
                            placeholder: 'createOrg.form.org.address.postcode',
                            autoComplete: 'postal-code'
                        },
                        {
                            type: 'text',
                            id: 'address_city',
                            placeholder: 'createOrg.form.org.address.city',
                            autoComplete: 'address-level2'
                        },

                    ]
                },
                {
                    type: 'country',
                    id: 'country',
                    displayField: 'countryName',
                    placeholder: 'organization.form.country',
                    name: 'country',
                    valueMap: {
                        'country': 'id',
                        'countryName': 'name',
                    },
                    required: true
                },
            ],
            buttons: [
                {
                    type: 'button',
                    id: 'createOrgCardOrganization.createOrgOrg.back',
                    action: 'back',
                    label: 'createOrg.form.org.button.back',
                    variant: 'secondary'
                },
                {
                    type: 'button',
                    id: 'createOrgCardOrganization.createOrgOrg.saveNContinue',
                    action: 'saveNContinue',
                    label: 'createOrg.form.org.button',
                    variant: 'primary'
                }

            ],
            displaySection: {
                emptyField: 'name',
                emptyMessage: 'organization.form.name.missing.message',
                columns: [
                    {
                        weight: 1,
                        basis: '100%',
                        elements: [
                            {
                                type: 'field',
                                value: 'name',
                                scale: 'title'
                            },
                            {
                                type: 'field',
                                value: 'email',
                                scale: 'normal'
                            }
                        ]
                    }
                ]
            }
        }]
    },

    createOrgCardUser: {
        entity: 'user',
        path: 'user',
        titleBar: { mergeParams: ['name'], new: 'createOrg.form.user.title' },
        cardTitle: {
            title: 'organization.form.new.title',
            menuItems: [
            ]
        },
        showCardTitle: false,
        afterSubmit: { stay: true },
        sections: [{
            id: 'createOrgUser',
            meta: {
                type: 'form',
                collapsible: false,
                width: '480px',
                variant: 'transparent'
            },
            groups: [
                {
                    type: 'text',
                    id: 'name',
                    label: 'createOrg.form.user.name',
                    placeholder: 'createOrg.form.user.placeholder',
                }],
            buttons: [
                {
                    type: 'button',
                    id: 'createOrgCardUser.createOrgUser.saveNContinue',
                    action: 'saveNContinue',
                    label: 'createOrg.form.user.button',
                    variant: 'primary'
                }
            ],
            displaySection: {
                emptyField: 'name',
                emptyMessage: 'organization.form.name.missing.message',
                columns: [
                    {
                        weight: 1,
                        basis: '100%',
                        elements: [
                            {
                                type: 'field',
                                value: 'name',
                                scale: 'title'
                            },
                            {
                                type: 'field',
                                value: 'email',
                                scale: 'normal'
                            }
                        ]
                    }
                ]
            }

        }]
    },

    employeeCard: {
        entity: 'employee',
        path: 'employee',
        titleBar: { mergeParams: ['name'], new: 'employee.form.new.title' },
        cardTitle: {
            title: 'employee.form.dropdown.toggle',
            width: '600px',
            buttons: [
                {
                    type: 'submit',
                    id: 'employeeCard.save',
                    action: 'save',
                    label: 'all.form.button.save',
                    icon: 'save',
                    variant: 'primary',
                    confirm: false
                }
            ],
            menuItems: [
                { action: 'deactivate', label: 'employee.form.deactivate', confirm: true, modalConfig: 'employeeConfirmDeactivate' },
                { action: 'delete', label: 'employee.form.delete', confirm: true, modalConfig: 'employeeConfirmDelete' }
            ]
        },
        width: '600px',
        sections: [
            {
                id: 'employee',
                meta: { type: 'form', width: '600px' },
                groups: [
                    {
                        type: 'connect',
                        id: 'linkedUserId',
                        displayField: 'linkedUserName',
                        label: 'employee.form.user',
                        modalTitle: 'employee.form.user.modal.title',
                        entity: 'user',
                        valueMap: { 'linkedUserId': 'id', 'linkedUserName': 'name', name: 'name' },
                        options: { withHeaders: false },
                        required: true
                    },
                    {
                        type: 'text',
                        id: 'name',
                        label: 'employee.form.displayName',
                        placeholder: 'employee.form.displayName.placeholder',
                        required: true
                    },
                    {
                        type: 'text',
                        id: 'title',
                        label: 'employee.form.title',
                        placeholder: 'employee.form.title.placeholder'
                    },
                    {
                        type: 'text',
                        id: 'department',
                        label: 'employee.form.department',
                        placeholder: 'employee.form.department.placeholder'
                    },
                    {
                        type: 'select',
                        id: 'active',
                        displayField: 'activeName',
                        label: 'employee.form.active',
                        entity: 'employeeActiveStatus',
                        valueMap: { 'active': 'id', 'activeName': 'name' },
                        options: { withHeaders: false },
                        required: true,
                    }
                ],
                buttons: [{
                    type: 'submit', id: 'employeeCard.employee.save', action: 'save',
                    label: 'all.form.button.update', icon: 'save',
                    variant: 'primary'
                }],
                displaySection: {
                    emptyField: 'name',
                    columns: [{
                        weight: 1, basis: '100%',
                        elements: [
                            { type: 'field', value: 'name', scale: 'title' },
                            { type: 'field', value: 'title', scale: 'normal' },
                            { type: 'field', value: 'department', scale: 'normal' }
                        ]
                    }]
                }
            },
            {
                id: 'employee.appRoles',
                meta: {
                    type: 'lines',
                    linesArray: 'appRoles',
                    linesAddAction: 'employee.form.appRoles.add',
                    width: '600px'
                },
                groups: [
                    {
                        type: 'select',
                        id: 'app',
                        displayField: 'appName',
                        label: 'employee.form.appRole.app',
                        entity: 'appRoleApp',
                        valueMap: { 'app': 'id', 'appName': 'name' },
                        options: { withHeaders: false },
                        required: true,
                    },
                    {
                        type: 'switchSelect',
                        id: 'role',
                        displayField: 'roleName',
                        label: 'employee.form.appRole.role',
                        entity: 'appRoleType',
                        valueMap: { 'role': 'id', 'roleName': 'name' },
                        options: { withHeaders: false },
                        required: true,
                    }
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'employeeCard.appRoles.delete',
                        action: 'delete',
                        label: 'all.form.button.delete',
                        icon: 'delete',
                        variant: 'danger',
                        size: 'icon'
                    },
                    {
                        type: 'button',
                        id: 'employeeCard.appRoles.save',
                        action: 'save',
                        label: 'all.form.button.save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'appName',
                    emptyMessage: 'employee.form.appRoles.empty',
                    editButtonRightOffset: '50%',
                    columns: [
                        {
                            weight: 6, basis: '60%',
                            elements: [
                                { type: 'field', value: 'appName', scale: 'title' }
                            ]
                        },
                        {
                            weight: 4, basis: '40%',
                            elements: [
                                { type: 'field', value: 'roleName', scale: 'normal' }
                            ]
                        }
                    ]
                }
            }
        ]
    },

    organizationCard: {
        entity: 'organization',
        path: 'organization',
        titleBar: { mergeParams: ['name'], new: 'organization.form.new.title' },
        cardTitle: {
            title: 'organization.form.dropdown.toggle',
            menuItems: [
                {
                    action: 'delete',
                    label: 'organization.form.dropdown.menu01',
                    confirm: true,
                    modalConfig: 'organizationConfirmDelete'
                },
                {
                    action: 'transact',
                    label: 'all.card.menu.transactions'
                },
                {
                    action: 'activate',
                    label: 'all.card.menu.activities'
                }

            ]
        },
        sections: [
            {
                id: 'organization',
                meta: {
                    type: 'form',
                    width: '360px'
                },
                groups: [
                    /*
                     * As on createOrgCardOrganization: the name doubles as a
                     * company register lookup that fills the name, address and
                     * VAT number, and sets the country to the company's.
                     */
                    {
                        type: 'companyLookup',
                        id: 'name',
                        parameter: 'country',
                        label: 'organization.form.name',
                        placeholder: 'organization.form.name.placeholder',
                        valueMap: {
                            'name': 'name',
                            'vatNumber': 'companyId',
                            'address_street': 'address.street',
                            'address_postCode': 'address.postalCode',
                            'address_city': 'address.city'
                        },
                        required: true
                    },
                    {
                        type: 'email',
                        id: 'email',
                        label: 'organization.form.email',
                        placeholder: 'organization.form.email.placeholder',
                    },
                    {
                        type: 'text',
                        id: 'address_street',
                        label: 'organization.form.address',
                        placeholder: 'organization.form.address.street',
                        fgMargin: '1.5rem',
                        autoComplete: 'address-line1'
                    },
                    {
                        type: 'group',
                        id: 'addressPostCodeCity',
                        fields: [
                            {
                                type: 'text',
                                id: 'address_postCode',
                                placeholder: 'organization.form.address.postcode',
                                autoComplete: 'postal-code'
                            },
                            {
                                type: 'text',
                                id: 'address_city',
                                placeholder: 'organization.form.address.city',
                                autoComplete: 'address-level2'
                            },

                        ]
                    },
                    {
                        type: 'country',
                        id: 'country',
                        displayField: 'countryName',
                        placeholder: 'organization.form.country',
                        valueMap: {
                            'country': 'id',
                            'countryName': 'name',
                        },
                        // The country decides the VAT codes, the currency and the
                        // chart of accounts: an organisation cannot be made without.
                        required: true
                    },
                    {
                        type: 'text',
                        id: 'vatNumber',
                        label: 'organization.form.vatNumber',
                        placeholder: 'organization.form.vatNumber.placeholder'
                    },
                ],
                buttons: [
                    {
                        type: 'submit',
                        id: 'organizationCard.organization.save',
                        action: 'save',
                        label: 'all.form.button.update',
                        icon: 'save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'name',
                    emptyMessage: 'organization.form.name.missing.message',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'name',
                                    scale: 'title'
                                },
                                {
                                    type: 'field',
                                    value: 'email',
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            }
        ]
    },

    portalCard: {
        entity: 'portal',
        path: 'portal',
        titleBar: { mergeParams: ['name'], new: 'portal.form.new.title' },
        cardTitle: {
            title: 'portal.form.dropdown.toggle',
            menuItems: [
                {
                    action: 'openUrl',
                    label: 'portal.list.line.open'
                },
                {
                    action: 'delete',
                    label: 'portal.form.dropdown.delete',
                    confirm: true,
                    modalConfig: 'confirmDelete'
                }
            ]
        },
        sections: [
            {
                id: 'portal',
                meta: {
                    type: 'form',
                    width: '360px'
                },
                groups: [
                    {
                        type: 'text',
                        id: 'name',
                        label: 'portal.form.name',
                        placeholder: 'portal.form.name.placeholder',
                        required: true
                    },
                    {
                        type: 'select',
                        id: 'type',
                        displayField: 'typeName',
                        label: 'portal.form.type',
                        placeholder: 'portal.form.type.placeholder',
                        entity: 'portalType',
                        valueMap: {
                            'typeName': 'name',
                            'type': 'id'
                        },
                        options: { withHeaders: false, autoSelectFirst: false },
                        required: true,
                        defaultType: 'none'
                    },
                    {
                        type: 'connect',
                        id: 'contactId',
                        displayField: 'contactName',
                        label: 'portal.form.contact',
                        placeholder: 'portal.form.contact.placeholder',
                        modalTitle: 'portal.form.contact',
                        entity: 'contact',
                        valueMap: {
                            'contactId': 'id',
                            'contactName': 'name'
                        },
                        options: { withHeaders: true },
                        condition: { field: 'type', operator: 'in', value: ['customerPortal', 'supplierPortal'] }
                    },
                    {
                        type: 'text',
                        id: 'email',
                        label: 'portal.form.email',
                        placeholder: 'portal.form.email.placeholder',
                        condition: { field: 'type', operator: 'in', value: ['invitation', 'joinOrganization', 'resetPassword'] }
                    },
                    {
                        type: 'switch',
                        id: 'enabled',
                        label: 'portal.form.enabled',
                        switchText: 'portal.form.enabled'
                    },
                    {
                        type: 'date',
                        id: 'expiresAt',
                        label: 'portal.form.expiresAt',
                        placeholder: 'portal.form.expiresAt.placeholder'
                    }
                ],
                buttons: [
                    {
                        type: 'submit',
                        id: 'portalCard.portal.save',
                        action: 'save',
                        label: 'all.form.button.update',
                        icon: 'save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'name',
                    emptyMessage: 'portal.form.name.missing.message',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'name',
                                    scale: 'title'
                                },
                                {
                                    type: 'field',
                                    value: 'contactName',
                                    scale: 'normal'
                                },
                                {
                                    type: 'field',
                                    value: 'type',
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            }
        ]
    },

    userCard: {
        entity: 'organizationUser',
        path: 'organizationUser',
        titleBar: { mergeParams: ['name'], new: 'user.form.new.title' },
        cardTitle: {
            title: 'user.form.dropdown.toggle',
            menuItems: [
                {
                    action: 'delete',
                    label: 'user.form.dropdown.menu01',
                    confirm: true,
                    modalConfig: 'userConfirmDelete'

                },
                {
                    action: 'transact',
                    label: 'all.card.menu.transactions'
                },
                {
                    action: 'activate',
                    label: 'all.card.menu.activities'
                }

            ]
        },
        width: '1024px',
        sections: [{
            id: 'user',
            meta: {
                type: 'form',
                width: '360px'
            },
            groups: [
                {
                    type: 'text',
                    id: 'name',
                    label: 'user.form.name',
                    placeholder: 'user.form.name.placeholder',
                },
                {
                    type: 'text-readOnly',
                    id: 'email',
                    label: 'user.form.email',
                    placeholder: 'user.form.email.placeholder',
                }
            ],
            buttons: [
                {
                    type: 'submit',
                    id: 'userCard.user.save',
                    action: 'save',
                    label: 'all.form.button.update',
                    icon: 'save',
                    variant: 'primary'
                }
            ],
            displaySection: {
                emptyField: 'name',
                emptyMessage: 'organization.form.name.missing.message',
                columns: [
                    {
                        weight: 1,
                        basis: '100%',
                        elements: [
                            {
                                type: 'field',
                                value: 'name',
                                scale: 'title'
                            },
                            {
                                type: 'field',
                                value: 'email',
                                scale: 'normal'
                            }
                        ]
                    }
                ]
            }
        }]
    },

    userCardNew: {
        entity: 'organizationUser',
        path: 'organizationUser',
        titleBar: { mergeParams: ['email'], new: 'user.form.invite.title' },
        sections: [{
            id: 'inviteUser',
            meta: {
                type: 'form',
                width: '360px'
            },
            groups: [
                {
                    type: 'email',
                    id: 'email',
                    label: 'user.form.email',
                    placeholder: 'user.form.email.placeholder',
                }
            ],
            buttons: [
                {
                    type: 'submit',
                    id: 'userCardNew.inviteUser.save',
                    action: 'save',
                    label: 'user.form.button.invite',
                    icon: 'save',
                    variant: 'primary'
                }
            ],
            displaySection: {
                emptyField: 'email',
                emptyMessage: 'user.form.email.missing.message',
                columns: [
                    {
                        weight: 1,
                        basis: '100%',
                        elements: [
                            {
                                type: 'field',
                                value: 'email',
                                scale: 'title'
                            }
                        ]
                    }
                ]
            }
        }]
    },
}
